import * as api from "@/apiv2/assignees";
import { createAction, createSetterActions } from "@/redux/helpers/action";
import { handleError } from "@/redux/utils/error";
import { STATUS } from "@/utils/constants";

import { MODULE } from "./constants";
import * as selectors from "./order-assign-user-via-context-menu.selectors";

export const [setIsFetchingUsersStatus, setUsers, setSelectedUsers, setUnSelectedUsers] =
  createSetterActions(MODULE, [
    "isFetchingUsersStatus",
    "users",
    "selectedUsers",
    "unSelectedUsers",
  ]);

export const reset = createAction(`${MODULE}/RESET`);

export const toggleUsers = (uid) => (dispatch, getState) => {
  const state = getState();
  const selectedUserUids = selectors.getSelectedUsers(state);
  const unSelectedUserUids = selectors.getUnSelectedUsers(state);

  if (selectedUserUids.includes(uid) && !unSelectedUserUids.includes(uid)) {
    dispatch(setUnSelectedUsers([...unSelectedUserUids, uid]));
  }

  if (!selectedUserUids.includes(uid) && unSelectedUserUids.includes(uid)) {
    dispatch(setUnSelectedUsers(unSelectedUserUids.filter((id) => id !== uid)));
  }

  const newSelectedUserUids = selectedUserUids.includes(uid)
    ? selectedUserUids.filter((id) => id !== uid)
    : [...selectedUserUids, uid];

  dispatch(setSelectedUsers(newSelectedUserUids));
};

// One person, saved the moment they are ticked or unticked. Resolves true on success, or the error
// on failure so the picker can undo the tick and word the message itself.
export const saveUserToggle =
  ({ orderUid, userId, isAssigned }) =>
  async () => {
    try {
      await api.postAssignUser({
        order: orderUid,
        users_assigned: isAssigned ? [userId] : [],
        users_not_assigned: isAssigned ? [] : [userId],
      })();
      return true;
    } catch (error) {
      return error;
    }
  };

export const fetchUsers = () => async (dispatch) => {
  try {
    dispatch(setIsFetchingUsersStatus(STATUS.PENDING));
    const response = await api.getUsers({ include_invites: false });
    dispatch(setUsers(response.data));
    dispatch(setIsFetchingUsersStatus(STATUS.FULFILLED));
  } catch (error) {
    dispatch(setIsFetchingUsersStatus(STATUS.REJECTED));
    // handleError rethrows for callers that await. Nobody awaits this fetch: the picker fires it
    // from an effect and shows an inline Retry, so the rethrow would only be an unhandled rejection.
    // It also used to run before the status update, which left the spinner up for good.
    try {
      handleError(error, dispatch);
    } catch {
      // Shown inline by the picker.
    }
  }
};

export const assignUsersToOrder = (uid) => async (dispatch, getState) => {
  try {
    const state = getState();
    const selectedUserUids = selectors.getSelectedUsers(state);
    const unSelectedUserUids = selectors.getUnSelectedUsers(state);

    const data = {
      users_assigned: selectedUserUids,
      users_not_assigned: unSelectedUserUids,
      order: uid,
    };

    await api.postAssignUser(data)();
  } catch (error) {
    handleError(error, dispatch);
  }
};
